/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../common/auto-form';
import { FAMILY_SAVINGS_INSURANCE_FIELDS } from './fields';
import { FamilySavingsInsuranceResultView } from './result-view';
import {
  FamilySavingsInsuranceFormValues,
  familySavingsInsuranceDefaults,
  familySavingsInsuranceSchema,
} from './schema';
import { PRODUCT, buildFamilySavingsPayload, simulateFamilySavingsInsurance } from './service';

export function FamilySavingsInsurancePage() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: FamilySavingsInsuranceFormValues) => (
      simulateFamilySavingsInsurance({ values })
    ),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={FAMILY_SAVINGS_INSURANCE_FIELDS}
            schema={familySavingsInsuranceSchema}
            defaults={familySavingsInsuranceDefaults}
            isLoading={mutation.isLoading}
            expectedProduct={PRODUCT}
            onSubmit={(values) => {
              const payload = {
                product: PRODUCT,
                ...buildFamilySavingsPayload(values),
                debug: true,
              };
              setLastRequest(payload);
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <FamilySavingsInsuranceResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
